import React from 'react'

export default function OnIcon() {
  return (
    <div className='d-flex justify-content-center align-items-center h-100'>
      <i
        className='bx bx-check'
        style={{
          color: "#ffffff",
          fontSize: "20px",
          height: "100%",
          lineHeight: "25px"
        }}
      />
    </div>
  )
}